import React from 'react'
import Select, { components } from 'react-select'
import { getRailsEnv } from '../../helpers/rails_helper'

const SearchSelect = ({
  id,
  name,
  options,
  selectedOption,
  isMulti,
  isClearable,
  placeholder,
  errorMessage,
  disabled,
  menuPlacement,
  menuPosition = 'absolute',
  hint
}) => {
  const Option = props => {
    const { label, cx, getStyles, isDisabled, isFocused, isSelected, innerProps, className } = props
    return (
      <div
        style={getStyles('option', props)}
        className={cx(
          {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
          },
          className
        )}
        aria-disabled={isDisabled}
        {...innerProps}
      >
        <div dangerouslySetInnerHTML={{ __html: label }} />
      </div>
    )
  }

  const customStyles = {
    control: (provided, state) => {
      let border = errorMessage ? 'solid 1px #f95a53' : state.isFocused ? 'solid 1px #2684FF' : 'solid 1px #DDDDDD'

      return {
        ...provided,
        border: border,
        '&:hover': {
          border: border
        }
      }
    },
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#edf0ff' : 'white',
      color: '#212529'
    })
  }

  const emitChange = event => {
    const customEvent = new CustomEvent('input:change', {
      detail: Array.isArray(event) ? event.map(buildEventDetail) : buildEventDetail(event)
    })
    requestAnimationFrame(() => {
      setTimeout(() => window.dispatchEvent(customEvent), 0)
    }) // wait until dom update resolves
  }

  const buildEventDetail = event => {
    return {
      label: event?.label,
      value: event?.value,
      id: id
    }
  }

  const CustomSingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <div dangerouslySetInnerHTML={{ __html: children }} />
    </components.SingleValue>
  );

  return (
    <>
      <Select
        components={{ SingleValue: CustomSingleValue, Option: Option }}
        inputId={id}
        defaultValue={selectedOption}
        className='basic-single'
        classNamePrefix='select'
        isSearchable
        isMulti={isMulti}
        isClearable={isClearable}
        name={name}
        placeholder={placeholder || 'Select'}
        options={options}
        styles={customStyles}
        isDisabled={disabled}
        onChange={emitChange}
        menuPlacement={menuPlacement}
        menuPosition={menuPosition} // Added to prevent fixed menus from scrolling out of their containers and messing with layouts. Native browser select captures scroll so this just brings the React Select in line
        menuShouldBlockScroll={getRailsEnv() === 'test' ? false : true} // Scroll blocker intercepts Selenium clicks, so we disable in test mode
      />
      {hint && <div class="form-text">{hint}</div>}
      {errorMessage && <div className='d-block invalid-feedback'>{errorMessage}</div>}
    </>
  )
}

export default SearchSelect
